import { render } from "./EditaEmpresaForm.vue?vue&type=template&id=22e7251a&scoped=true"
import script from "./EditaEmpresaForm.vue?vue&type=script&lang=js"
export * from "./EditaEmpresaForm.vue?vue&type=script&lang=js"

import "./EditaEmpresaForm.vue?vue&type=style&index=0&id=22e7251a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22e7251a"]])

export default __exports__